// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
// material
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import Page from '../../components/Page';
import { Formik } from 'formik';
import { TimePicker, LocalizationProvider } from '@mui/lab';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import styled from '@emotion/styled';
import Iconify from '../../components/Iconify';
import * as Yup from 'yup';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import toast from 'react-hot-toast';
import {
  useSaveParkingSpaceLocationMutation,
  useUploadParkingImagesMutation,
  useFindParkingSpaceLocationByIdMutation,
  useUpdateParkingSpaceLocationMutation,
} from '../../store/api/parkingsApi';
import Loading from '../../components/Loading';
import LocationSearchInput from '../../sections/@dashboard/parkingspaces/PlaceLocationAutoComplete';
import { useGetParkingTypeDataMutation } from '../../store/api/parkingTypeApi';
import { useGetEnumDataMutation } from '../../store/api/enumApi';
import { getSpecificEnumData, setEnumData } from '../../store/state/enumSlice';

const Input = styled('input')({
  display: 'none',
});

const TIER_TYPE = [
  { id: 'T1', value: 'T1' },
  { id: 'T2', value: 'T2' },
  { id: 'T3', value: 'T3' },
];

const ParkingSchema = Yup.object().shape({
  capacity: Yup.number().required('Capacity is required').min(10, 'Capacity must be at least 10'),
  closeAt: Yup.string().required('closing time is required'),
  description: Yup.string().required('Description is required'),
  name: Yup.string().required('Name is required'),
  serviceProviderId: Yup.string(),
  openAt: Yup.string().required('opening time is required'),
  phoneNumber: Yup.string().required('Phone number is required'),
  hourlyLimit: Yup.number().required('Hourly limit is required').min(0).max(24),
  hourlyRate: Yup.number().required('Hourly rate is required').min(0).max(999),
  dailyLimit: Yup.number().required('Daily limit is required').min(0).max(24),
  dailyRate: Yup.number().required('Daily rate is required').min(0).max(999),
  tierType: Yup.string().required('Tier Type is required'),
  commission: Yup.string().required('Commission is required'),
  termAndCondition: Yup.boolean().required('Terms and condition is required'),
  cancellationFee: Yup.number().required('Cancellation fee is required').min(0).max(999),
  cancellationDueTime: Yup.number().required('Cancellation due time is required').min(0).max(24),
  security: Yup.boolean().required('Security is required'),
  discount: Yup.number()
    .required('Discount is required')
    .min(0, 'Discount must be at least 0')
    .max(60, 'Discount must be at most 60'),
});

export default function ReviewParkingDetails() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    address: '',
    name: '',
    openAt: '2018-01-01T00:00:00.000Z',
    closeAt: '2018-01-01T00:00:00.000Z',
    capacity: 0,
    description: '',
    phoneNumber: '',
    security: false,
    valet: false,
    chargingStation: false,
    servicing: false,
    wash: false,
    AdaAisleAccess: false,
    termAndCondition: false,
    parkingCategory: '',
    photos: '',
    serviceProviderId: '',
    latitude: '',
    longitude: '',
    discount: 0,
    hourlyLimit: '',
    hourlyRate: '',
    dailyLimit: '',
    dailyRate: '',
    tierType: '',
    commission: '',
    cancellationFee: '',
    cancellationDueTime: '',
    parkingTypeId: '',
  });

  const [itemData, setItemData] = useState([]);
  const token = JSON.parse(localStorage.getItem('login')).token || null;
  const [findParkingSpaceLocationById, findByIdResponse] = useFindParkingSpaceLocationByIdMutation();
  const [updateParkingSpaceLocation, updateResponse] = useUpdateParkingSpaceLocationMutation();
  const [uploadParkingImages, uploadResponse] = useUploadParkingImagesMutation();
  const [getParkingTypeData, getParkingTypeDataResponse] = useGetParkingTypeDataMutation();
  const [address, setAddress] = useState(null);
  const [addressValue, setAddressValue]: any = useState(null);
  const { state } = useLocation();
  const [currentStep, setCurrentStep] = useState(0);
  const [allDisabled, setAllDisabled] = useState(false);
  const [updatedData, setUpdatedData]: any = useState();
  const [parkingManagementData, setParkingManagementData] = useState([]);
  const [tierType, setTierType] = useState([]);
  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  let enumData: any = useAppSelector(getSpecificEnumData);
  const [marchantType, setMarchantType] = useState([]);
  const dispatch = useAppDispatch();

  const uploadImages = (parkingId) => {
    itemData.forEach((item) => {
      const formData = new FormData();
      formData.append('file', item.file);
      uploadParkingImages({
        token: token,
        parkingLocationId: parkingId,
        docType: 'jpeg',
        payload: formData,
      });
    });
  };

  const getParkingTypeDataAsync = async (rowPerPages: any, pages: number, orders: string, typeNames = '') => {
    await getParkingTypeData({
      token: token,
      payload: { offset: rowPerPages, pageNumber: pages, sortOrder: orders, typeName: typeNames },
    });
  };

  useEffect(() => {
    if (token) {
      getParkingTypeDataAsync(2000, 0, 'desc');
    }
  }, []);

  useEffect(() => {
    if (getParkingTypeDataResponse.isSuccess) {
      const parkingType = getParkingTypeDataResponse.data.data.filter((item) => {
        return item.status == true;
      });
      setParkingManagementData(parkingType);
    }
  }, [getParkingTypeDataResponse.isSuccess]);

  useEffect(() => {
    if (uploadResponse.isSuccess) {
      navigate('/dashboard/all-parking-spaces', { replace: true });
    }
  }, [uploadResponse.isSuccess]);

  useEffect(() => {
    if (updateResponse.isSuccess) {
      if (itemData.length > 0) {
        uploadImages(updateResponse.data.id);
      } else {
        toast.success('Parking space added successfully');
        navigate('/dashboard/all-parking-spaces', { replace: true });
      }
    }
  }, [updateResponse.isSuccess]);

  useEffect(() => {
    findParkingSpaceLocationById({ id: state.parkingId, token: token });
  }, []);

  useEffect(() => {
    getEnumData({ token: token });
  }, []);

  useEffect(() => {
    if (enumResponse.isSuccess) {
      dispatch(setEnumData(enumResponse.data));
    }
  }, [enumResponse.isSuccess]);

  useEffect(() => {
    if (enumData) {
      setMarchantType(enumData['AMENITIES_TYPE']);
      setTierType(enumData['TIER_TYPE']);
    }
  }, [enumData]);

  useEffect(() => {
    if (findByIdResponse.isSuccess) {
      setAddressValue(() => findByIdResponse.data.address);
      setFormValues(() => {
        return {
          address: findByIdResponse.data.address,
          name: findByIdResponse.data.name,
          openAt: findByIdResponse.data.openAt,
          closeAt: findByIdResponse.data.closeAt,
          capacity: findByIdResponse.data.capacity,
          description: findByIdResponse.data.listingDescription,
          phoneNumber: findByIdResponse.data.phoneNumber,
          security: findByIdResponse.data.hasSecurity,
          valet: findByIdResponse.data.hasValet,
          chargingStation: findByIdResponse.data.hasChargingStation,
          servicing: findByIdResponse.data.hasServicing,
          wash: findByIdResponse.data.hasWash,
          AdaAisleAccess: findByIdResponse.data.hasADA,
          termAndCondition: findByIdResponse.data.termAndCondition === 'true' ? true : false,
          parkingCategory: findByIdResponse.data.parkingCategory,
          discount: findByIdResponse.data.discount,
          serviceProviderId: findByIdResponse.data.serviceProviderId,
          photos: '',
          parkingTypeId: findByIdResponse.data.parkingTypeId,
          hourlyLimit: findByIdResponse.data.hourlyLimit,
          hourlyRate: findByIdResponse.data.hourlyRate,
          dailyLimit: findByIdResponse.data.dailyLimit,
          dailyRate: findByIdResponse.data.dailyRate,
          tierType: findByIdResponse.data.tierType,
          commission: findByIdResponse.data.commission,
          cancellationFee: findByIdResponse.data.cancellationFee,
          cancellationDueTime: findByIdResponse.data.cancellationDueTime,
          latitude: findByIdResponse.data.latitude,
          longitude: findByIdResponse.data.longitude,
        };
      });
    }
  }, [findByIdResponse.isSuccess]);

  const updateDataInServer = async (values) => {
    await updateParkingSpaceLocation({
      payload: {
        id: state.parkingId,
        address: values.address ? values.address : address?.formatted_address,
        capacity: values.capacity,
        cityId: 2,
        cityName: values.cityName ? values.cityName : address?.city,
        stateName: values.stateName ? values.stateName : address?.state,
        countryName: values.countryName ? values.countryName : address?.country,
        postalcodeName: values.postalcodeName ? values.postalcodeName : address?.postalcode,
        closeAt: values.closeAt,
        currentStatus: 'active',
        status: true,
        description: values.description,
        hasADA: values.AdaAisleAccess,
        hasChargingStation: values.chargingStation,
        hasSecurity: values.security,
        hasServicing: values.servicing,
        hasValet: values.valet,
        hasWash: values.wash,
        latitude: values.latitude ? values.latitude : address?.lat,
        longitude: values.longitude ? values.longitude : address?.lng,
        name: values.name,
        openAt: values.openAt,
        parkingCategory: values.parkingCategory,
        parkingRate: values.parkingRate,
        parkingRefundType: true,
        phoneNumber: values.phoneNumber,
        termAndCondition: values.termAndCondition,
        discount: values.discount,
        serviceProviderId: values.serviceProviderId,
        parkingTypeId: values.parkingTypeId,
        hourlyLimit: values.hourlyLimit,
        hourlyRate: values.hourlyRate,
        dailyLimit: values.dailyLimit,
        dailyRate: values.dailyRate,
        tierType: values.tierType,
        commission: values.commission,
        cancellationFee: values.cancellationFee,
        cancellationDueTime: values.cancellationDueTime,
      },
      token: token,
    });
  };

  const handleAddNewParking = (values, action) => {
    setCurrentStep(1);
    setAllDisabled(true);
    setUpdatedData(values);
  };

  return (
    <Page title="Parking Space">
      <Box display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'}>
        <Box style={{ fontWeight: currentStep === 0 ? 'bold' : 'normal' }}>1. Under Approval</Box>
        <Box style={{ border: `1px solid #0000002f`, width: '50px', margin: '0px 20px' }}></Box>
        <Box style={{ fontWeight: currentStep === 1 ? 'bold' : 'normal' }}>2. Confirm Approval</Box>
      </Box>
      <Formik
        enableReinitialize={true}
        initialValues={formValues}
        onSubmit={handleAddNewParking}
        validationSchema={ParkingSchema}
      >
        {({ values, errors, touched, handleChange, setFieldValue, handleBlur, handleSubmit }) => {
          return (
            <Container
              sx={{
                paddingTop: '2rem',
                paddingBottom: '2rem',
              }}
            >
              <Typography variant="h3" marginBottom={'20px'} component="div">
                {currentStep === 0 && 'Review Changes'}
                {currentStep === 1 && 'Confirm Changes'}
              </Typography>
              <Typography variant="h5" gutterBottom component="div">
                Parking Location
              </Typography>

              {addressValue != null && (
                <LocationSearchInput
                  disabled={allDisabled}
                  locationDetail={setAddress}
                  value={addressValue}
                ></LocationSearchInput>
              )}
              <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
                <Box width="70%">
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Parking Space Name
                  </Typography>
                  {/* Parking space name */}
                  <TextField
                    fullWidth
                    autoComplete="name"
                    type="text"
                    name="name"
                    label="Enter name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.name && errors.name)}
                    helperText={touched.name && errors.name}
                  />
                </Box>
                <Box marginLeft={'40px'}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Phone Number
                  </Typography>
                  <TextField
                    type="text"
                    name="phoneNumber"
                    label="Enter Phone Number"
                    value={values.phoneNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.phoneNumber && errors.phoneNumber)}
                    helperText={touched.phoneNumber && errors.phoneNumber}
                  />
                </Box>
              </Box>
              {/* Opens and closes at */}
              <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <TimePicker
                    label="Enter opens at"
                    value={values.openAt}
                    onChange={(newValue) => {
                      handleChange({ target: { name: 'openAt', value: newValue?.toString() } });
                    }}
                    error={Boolean(touched.openAt && errors.openAt)}
                    helperText={touched.openAt && errors.openAt}
                    renderInput={(params) => <TextField sx={{ marginTop: 3, marginRight: 5 }} {...params} />}
                  />
                  <TimePicker
                    label="Enter closes at"
                    value={values.closeAt}
                    error={Boolean(touched.closeAt && errors.closeAt)}
                    helperText={touched.closeAt && errors.closeAt}
                    onChange={(newValue) => {
                      handleChange({ target: { name: 'closeAt', value: newValue?.toString() } });
                    }}
                    renderInput={(params) => <TextField sx={{ marginTop: 3 }} {...params} />}
                  />
                </LocalizationProvider>
                <Box style={{ marginLeft: '40px', marginTop: '25px' }}>
                  <TextField
                    id="parking-capacity"
                    label="Enter parking capacity"
                    value={values.capacity}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="capacity"
                    error={Boolean(touched.capacity && errors.capacity)}
                    helperText={touched.capacity && errors.capacity}
                    type={'number'}
                  />
                </Box>
              </Box>
              <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
                <Box>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Hourly Limit
                  </Typography>
                  <Stack direction="row" alignItems="center">
                    <TextField
                      id="hourly-limit"
                      label="Enter hourly limit"
                      value={values.hourlyLimit}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="hourlyLimit"
                      error={Boolean(touched.hourlyLimit && errors.hourlyLimit)}
                      helperText={touched.hourlyLimit && errors.hourlyLimit}
                      type={'number'}
                    />
                  </Stack>
                </Box>
                <Box style={{ marginLeft: '40px' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Hourly Rate
                  </Typography>
                  <TextField
                    id="hourly-rate"
                    label="Enter hourly rate"
                    value={values.hourlyRate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="hourlyRate"
                    error={Boolean(touched.hourlyRate && errors.hourlyRate)}
                    helperText={touched.hourlyRate && errors.hourlyRate}
                    type={'number'}
                  />
                </Box>
                <Box style={{ marginLeft: '40px' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Daily Limit
                  </Typography>
                  <Stack direction="row" alignItems="center">
                    <TextField
                      id="daily-limit"
                      label="Enter daily limit"
                      value={values.dailyLimit}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="dailyLimit"
                      error={Boolean(touched.dailyLimit && errors.dailyLimit)}
                      helperText={touched.dailyLimit && errors.dailyLimit}
                      type={'number'}
                    />
                  </Stack>
                </Box>
                <Box style={{ marginLeft: '40px' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Daily Rate
                  </Typography>
                  <TextField
                    id="daily-rate"
                    label="Enter daily rate"
                    value={values.dailyRate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="dailyRate"
                    error={Boolean(touched.dailyRate && errors.dailyRate)}
                    helperText={touched.dailyRate && errors.dailyRate}
                    type={'number'}
                  />
                </Box>
              </Box>
              <Box display={'flex'} alignItems={'center'} marginTop={'25px'}>
                <Box>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Cancellation Fee
                  </Typography>
                  <Stack direction="row" alignItems="center">
                    <TextField
                      id="cancellation-fee"
                      label="Enter cancellation fee"
                      value={values.cancellationFee}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="cancellationFee"
                      error={Boolean(touched.cancellationFee && errors.cancellationFee)}
                      helperText={touched.cancellationFee && errors.cancellationFee}
                      type={'number'}
                    />
                  </Stack>
                </Box>
                <Box style={{ marginLeft: '40px' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Cancellation Due Time
                  </Typography>
                  <TextField
                    id="cancellation-due-time"
                    label="Enter cancellation due time"
                    value={values.cancellationDueTime}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="cancellationDueTime"
                    error={Boolean(touched.cancellationDueTime && errors.cancellationDueTime)}
                    helperText={touched.cancellationDueTime && errors.cancellationDueTime}
                    type={'number'}
                  />
                </Box>
                <Box width="20%" style={{ marginLeft: '40px' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Tier Type
                  </Typography>
                  <Select
                    name="tierType"
                    id="tierType"
                    key={values.tierType}
                    value={values.tierType}
                    style={{
                      width: '100%',
                    }}
                    onChange={handleChange}
                    error={Boolean(touched.tierType && errors.tierType)}
                    displayEmpty
                    defaultValue={''}
                  >
                    <MenuItem disabled value="">
                      Select tier type
                    </MenuItem>
                    {tierType &&
                      tierType.map((tierTypes: any) => (
                        <MenuItem key={tierTypes.code} value={state.editMode ? values.tierType : tierTypes.code}>
                          {tierTypes.displayValue}
                        </MenuItem>
                      ))}
                  </Select>
                </Box>
                <Box style={{ marginLeft: '40px' }}>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Commission
                  </Typography>
                  <TextField
                    id="comission"
                    label="Enter commission"
                    value={values.commission}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    name="commission"
                    error={Boolean(touched.commission && errors.commission)}
                    helperText={touched.commission && errors.commission}
                    type={'number'}
                  />
                </Box>
              </Box>
              <Box sx={{ marginTop: '25px' }}>
                <Box>
                  <Typography variant="h5" marginTop={2} gutterBottom component="div">
                    Parking Type
                  </Typography>
                  <Select
                    id="parkingTypeId"
                    name="parkingTypeId"
                    style={{ width: '50%' }}
                    value={values.parkingTypeId}
                    onChange={(event: any) => {
                      setFieldValue('parkingTypeId', event.target.value);
                    }}
                    onBlur={handleBlur}
                    error={Boolean(touched.parkingTypeId && errors.parkingTypeId)}
                    displayEmpty
                    defaultValue={''}
                  >
                    <MenuItem disabled value="">
                      Select parking type
                    </MenuItem>
                    {parkingManagementData.map((parkingType, any, index: number) => (
                      <MenuItem value={parkingType.id} key={parkingType.id}>
                        {parkingType.typeName}
                      </MenuItem>
                    ))}

                    {/* <MenuItem value={1}>Flat price</MenuItem> */}
                  </Select>
                </Box>
              </Box>
              <Box sx={{ marginTop: '25px' }}>
                <Typography variant="h5" marginTop={2} gutterBottom component="div">
                  Description
                </Typography>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Enter description"
                  value={values.description}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="description"
                  multiline
                  rows={3}
                  error={Boolean(touched.description && errors.description)}
                  helperText={touched.description && errors.description}
                  disabled={allDisabled}
                />
              </Box>
              <Box>
                <Box marginBottom={10}>
                  <Box sx={{ marginTop: '25px' }}>
                    <Box>
                      <p style={{ fontWeight: 'bold', color: 'black', fontSize: '20px' }}>Amenities</p>
                    </Box>
                    <Box>
                      {marchantType &&
                        marchantType.map((marchanTypes: any) => (
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  onChange={(event: any) => {
                                    handleAmenities(event.target);
                                  }}
                                  onBlur={handleBlur}
                                  name={marchanTypes.code}
                                  checked={values.amenitiesList}
                                  defaultChecked={state.editMode && values[marchanTypes.code] ? true : false}
                                  value={values.amenitiesList}
                                />
                              }
                              label={marchanTypes.displayValue}
                            />
                          </FormGroup>
                        ))}
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box marginTop={'25px'}>
                <Typography variant="h5" marginTop={2} gutterBottom component="div" disabled={allDisabled}>
                  Upload Photos
                </Typography>
                <label htmlFor="contained-button-file">
                  <Input
                    accept="image/*"
                    id="contained-button-file"
                    disabled={allDisabled}
                    onChange={(data) => {
                      const reader = new FileReader();

                      reader.onload = () => {
                        if (reader.readyState === 2) {
                          setItemData((prev) => {
                            return [
                              ...prev,
                              {
                                id: Math.round(Math.random() * 100 + new Date().getTime()),
                                img: reader.result,
                                type: data.target.files[0].type,
                                file: data.target.files[0],
                              },
                            ];
                          });
                        }
                      };

                      reader.readAsDataURL(data.target.files[0]);
                    }}
                    multiple
                    type="file"
                  />
                  <Button variant="contained" size="large" component="span">
                    <Iconify icon={'bxs:image-add'} sx={{ mr: 1, width: 20, height: 20 }} />
                    Upload
                  </Button>
                  <Box sx={{ padding: '20px' }}>
                    {itemData.length > 0 &&
                      itemData.map((item) => (
                        <img
                          key={item.id}
                          src={`${item.img}`}
                          height={250}
                          width={250}
                          srcSet={`${item.img}`}
                          alt={item.title}
                        />
                      ))}
                  </Box>
                </label>
                {errors.photos && touched.photos && <Box sx={{ color: 'red' }}>{errors.photos}</Box>}
              </Box>
              <Box sx={{ marginTop: '25px' }}>
                <Typography variant="h5" marginTop={2} gutterBottom component="div">
                  Add Terms & Conditions
                </Typography>
                <FormGroup>
                  <Stack direction="row" alignItems={'center'}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="termAndCondition"
                          checked={values.termAndCondition}
                          onChange={() => setFieldValue('termAndCondition', !values.termAndCondition)}
                          onBlur={handleBlur}
                          disabled={allDisabled}
                        />
                      }
                    />
                    <Typography variant="body1" component="span">
                      I agree to the <Link to="/terms-and-conditions"> Terms and Conditions</Link>
                    </Typography>
                  </Stack>
                  {touched.termAndCondition && errors.termAndCondition && (
                    <Typography variant="body1" component="span">
                      {errors.termAndCondition}
                    </Typography>
                  )}
                </FormGroup>
              </Box>
              {currentStep === 0 && (
                <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => {
                      navigate('/dashboard/new-parking-requests');
                    }}
                    sx={{ marginRight: '10px' }}
                    size="large"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleChange({
                        target: {
                          name: 'photos',
                          value: [itemData],
                        },
                      });

                      handleSubmit();
                      window.scrollTo(0, 0);
                    }}
                    size="large"
                  >
                    Next
                  </Button>
                </div>
              )}
              {currentStep === 1 && (
                <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => {
                      setCurrentStep(0);
                      setAllDisabled(false);
                    }}
                    sx={{ marginRight: '10px' }}
                    size="large"
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      toast.success('Parking added successfully');
                      updateDataInServer(updatedData);
                    }}
                    size="large"
                  >
                    Confirm
                  </Button>
                </div>
              )}
            </Container>
          );
        }}
      </Formik>
      {findByIdResponse.isLoading || updateResponse.isLoading ? <Loading /> : null}
    </Page>
  );
}
